import { useEffect } from 'react';

/** Applies the per-page <title> and <body> classes that each legacy HTML page used to declare. */
export function usePage({ title, bodyClass }) {
  useEffect(() => {
    const prevTitle = document.title;
    const prevClass = document.body.className;
    if (title) document.title = title;
    document.body.className = bodyClass || '';
    return () => {
      document.title = prevTitle;
      document.body.className = prevClass;
    };
  }, [title, bodyClass]);
}

/**
 * Runs a legacy imperative controller (Leaflet maps, live DOM rendering) once the page markup is mounted.
 * `loader` is a dynamic import so each controller only ships with its own page.
 */
export function useLegacyController(loader) {
  useEffect(() => {
    let cancelled = false;
    loader()
      .then((mod) => {
        if (!cancelled && typeof mod.init === 'function') mod.init();
      })
      .catch((err) => console.error('Page controller failed to start:', err));
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
